module.exports = __webpack_public_path__ + "media/images/ministere-hover 2-fd1a5b02d9c866efb1e587548078055f.png";